/**
 * Elevation language: exactly three shadows.
 *   resting — cards and list items
 *   raised  — hover states, popovers
 *   overlay — dialogs, drawers
 * Shadow color is derived from navy950 so elevation reads consistently on
 * both light and navy-dark surfaces.
 */
export const shadows = {
  resting: "0 1px 3px rgba(20, 21, 31, 0.10)",
  raised: "0 4px 12px rgba(20, 21, 31, 0.14)",
  overlay: "0 12px 32px rgba(20, 21, 31, 0.22)",
} as const;
